import { Theme, ThemeProps } from '@theme/base';
import { SectionTitleSizes } from '@components/common/section-title';
import { useSelector } from 'react-redux';
import { getRecentlyViewed, RecentlyViewedItem } from '@state/slices/recently-viewed';
import React from 'react';
import { RecentlyViewed } from '@components/recently-viewed/RecentlyViewed';
import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';

export interface RecentlyViewedFITContainerProps {
  theme?: Theme;
  cmsConfig: any;
  titleSize: SectionTitleSizes;
}

const NoRecentlyViewed: any = styled.div(({ theme }: ThemeProps) => ({
  marginTop: -theme.custom.spacing.xxxLarge,

  [mq.medium]: {
    marginTop: -2 * theme.custom.spacing.xxxLarge
  }
}));

export const RecentlyViewedContainer = (props: RecentlyViewedFITContainerProps) => {
  const recentlyViewed: Array<RecentlyViewedItem> = useSelector(getRecentlyViewed);
  if (!recentlyViewed.length) return <NoRecentlyViewed />;
  const title: string = props.cmsConfig.title;
  return <RecentlyViewed recentlyViewed={recentlyViewed} title={title} />;
};
